import { S } from '../core/game';
import { bus } from '../core/bus';

/** Shared API: NPC memory and the growth record (the classroom package builds the UI on top). */
export function remember(npc: string, flag: string): void {
  const m = S().memory;
  const list = (m[npc] ??= []);
  if (!list.includes(flag)) list.push(flag);
}
export function recalls(npc: string, flag: string): boolean {
  return !!S().memory[npc]?.includes(flag);
}
/** Log a notable moment: `key` is a translation key in `classroom.journalKeys` (or any namespace the UI knows). */
export function logJournal(icon: string, key: string, arg?: string): void {
  const s = S();
  s.journal.push({ day: s.week * 3 + s.dayIndex, icon, key, arg });
  if (s.journal.length > 80) s.journal.splice(0, s.journal.length - 80);
  bus.emit('change');
}
/** Bump a hobby (music, art, sport, reading, nature, craft…). */
export function practice(hobby: string, n = 1): void {
  const h = S().hobbies;
  h[hobby] = (h[hobby] ?? 0) + n;
}
